import { useEffect, useState } from "react";
import { alpha } from "@mui/material/styles";
import {
  Box,
  Divider,
  Typography,
  Stack,
  MenuItem,
  Avatar,
  IconButton,
  Popover,
} from "@mui/material";
import { useNavigate } from "react-router";
import { GetLocalStorage } from "../../../utils/local-storage";
import { usePersistentState } from "../../../contexts/global-context";
import APIS from "../../../config/api";
import { GET } from "../../../config/https";

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: "Home",
    icon: "eva:home-fill",
    path: "/home",
  },
  {
    label: "Profile",
    icon: "eva:person-fill",
    path: "/dashboard/profile",
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const [open, setOpen] = useState<any>(null);
  const navigate = useNavigate();
  const [loginInfo, setLoginInfo] = useState<any>(false);
  const [state]: any = usePersistentState();
  const [user, setUser] = useState<any>({});

  useEffect(() => {
    GetUserData();
  }, []);

  const GetUserData = async () => {
    let userData = GetLocalStorage("loginData");
    let params: any = {
      id: userData.id,
    };
    await GET(APIS.GET_USER_BY_ID, params)
      .then((res: any) => {
        if (res?.isSuccess) {
          setUser(res.result);
          localStorage.setItem("userInfo", JSON.parse(res.result));
        }
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    let tempData = GetLocalStorage("loginData");
    setLoginInfo(tempData);
  }, [state.users]);
  const handleOpen = (event: any) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  const handleMenuItemClick = (path: any) => {
    navigate(path);
    setOpen(null);
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={user?.profileImage} alt="photoURL" />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            "& .MuiMenuItem-root": {
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {loginInfo.firstName} {loginInfo.lastName}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            {loginInfo.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: "dashed" }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option, index) => (
            <MenuItem
              key={index}
              onClick={() => handleMenuItemClick(option.path)}
            >
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: "dashed" }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </Popover>
    </>
  );
}
